export type CalendarCatalogErrorCode =
  | 'INVALID_SOURCE_KEY'
  | 'INVALID_SYSCAL_ID'
  | 'DGPA_CSV_INVALID'
  | 'DGPA_HEADER_INVALID'
  | 'DGPA_DATE_INVALID'
  | 'DGPA_DUPLICATE_DATE'
  | 'DGPA_YEAR_COVERAGE_INVALID'
  | 'DGPA_WEEKDAY_MISMATCH'
  | 'DGPA_STATUS_INVALID'
  | 'CALENDAR_NOT_FOUND'
  | 'CALENDAR_RELEASE_NOT_PUBLISHED'
  | 'CALENDAR_RELEASE_YEAR_MISMATCH'
  | 'CALENDAR_RELEASE_SOURCE_MISMATCH'
  | 'CALENDAR_PIN_ALREADY_EXISTS'
  | 'CALENDAR_PIN_NOT_FOUND'
  | 'CALENDAR_PIN_FROM_RELEASE_MISMATCH'
  | 'CALENDAR_WORKDAY_TEMPLATE_REQUIRED'
  | 'CALENDAR_WORKDAY_TEMPLATE_INVALID'
  | 'SYSCAL_RESERVED_ID'
  | 'SYSCAL_UNOWNED_ID'
  | 'SYSCAL_MANAGED_CONTENT_DRIFT'
  | 'SYSCAL_ORDER_INVALID'
  | 'CALENDAR_EXTENSION_INVALID';

export class CalendarCatalogError extends Error {
  readonly code: CalendarCatalogErrorCode;

  constructor(code: CalendarCatalogErrorCode, message: string) {
    super(message);
    this.name = 'CalendarCatalogError';
    this.code = code;
  }
}

export function fail(code: CalendarCatalogErrorCode, message: string): never {
  throw new CalendarCatalogError(code, message);
}
